import feature from './Feature'

export default feature
